<template>
  <button type="button" class="ai-switch" :class="{ on: value, lg: size === 'lg' }"
          role="switch" :aria-checked="value" @click="$emit('input', !value)">
    <span class="track"></span>
    <span class="thumb"></span>
  </button>
</template>

<script>
export default {
  name: 'AiSwitch',
  props: {
    value: { type: Boolean, default: false },
    size: { type: String, default: 'md' }, // 'md' | 'lg'
  },
};
</script>

<style scoped>
.ai-switch {
  position: relative; display: inline-flex; align-items: center;
  width: 46px; height: 26px; padding: 0; border: 0; background: none;
  cursor: pointer; flex-shrink: 0; outline: none;
}
.ai-switch.lg { width: 54px; height: 30px; }
.track {
  position: absolute; inset: 0; border-radius: 999px;
  background: #cbd5e1; transition: background .22s cubic-bezier(.4,0,.2,1);
}
.ai-switch.on .track { background: linear-gradient(135deg, #22c55e, #16a34a); }
.thumb {
  position: absolute; top: 3px; left: 3px; width: 20px; height: 20px;
  border-radius: 50%; background: #fff; box-shadow: 0 1px 3px rgba(0,0,0,.28);
  transition: transform .22s cubic-bezier(.4,0,.2,1);
}
.ai-switch.lg .thumb { width: 24px; height: 24px; }
.ai-switch.on .thumb { transform: translateX(20px); }
.ai-switch.lg.on .thumb { transform: translateX(24px); }
.ai-switch:focus-visible .track { box-shadow: 0 0 0 3px rgba(34,197,94,.3); }
</style>
